import callCmAPI from 'services/helpers/call-cm-api'
import { WebApi2Response } from 'types'
import { toQueryString } from './nordic-lookups-query'

/******************
 * Types          *
 ******************/

// A lookup is one company, by one account, on one UTC day (ENG2-2849). "With
// financial" means at least one of the four financial endpoints was called.
export interface LookupUsageMetrics {
  unique_companies: number
  unique_with_financial: number
  unique_without_financial: number
  daily_lookups: number
  daily_with_financial: number
  daily_without_financial: number
}

export interface LookupUsageEndpoint {
  endpoint: string
  counted: boolean // false: traced, but not part of the totals
  financial: boolean
  unique_companies: number
  daily_lookups: number
}

export interface LookupUsageResponse {
  company_id: number
  year: number | null
  month: number | null
  years: number[] // newest first; empty for a customer without lookups
  first_lookup_at: string | null
  last_lookup_at: string | null
  totals: LookupUsageMetrics
  months: (LookupUsageMetrics & { month: string })[] // "2026-10", oldest first
  countries: (LookupUsageMetrics & { country: string })[]
  channels: (LookupUsageMetrics & { channel: string })[]
  endpoints: LookupUsageEndpoint[] // counted first, busiest first
}

export interface LookupUsageParams {
  year?: number
  month?: number
}

/******************
 * Fetch from API *
 ******************/

export const getLookupUsage = (
  customerId: number | string,
  params: LookupUsageParams = {},
): Promise<WebApi2Response<LookupUsageResponse>> =>
  callCmAPI(
    `/lookup-usage/${customerId}${toQueryString({
      year: params.year,
      month: params.month,
    })}`,
    { method: 'get' },
  )
    .then((res) => ({
      success: true as const,
      data: res.data as LookupUsageResponse,
    }))
    .catch((err) => ({ success: false as const, data: null, error: err }))
